// === onLoad.js START ============================================================================

$(function () {

    InstallHandlebarsHelpers();
    InitCalendar();
    ApplyClickEvents();
    SetupWizard();

    // TODO Remove this later
    $('#btn-error-test').click(function () {
        ShowErrorPanel("Beispieltext für aufgetretenen Fehler");
    });
    $('#btn-conflict-test').click(function () {
        OpenModal("conflict");
    });

    // Height calculation
    (function () {
        var body = document.body,
            html = document.documentElement;
        var formerHeight = -1;
        var wrapper = $modal.find('.m-modal__wrapper');

        var doResize = function () {
            var offset = 50;
            var wrapperTop = wrapper.position().top;
            var height = body.clientHeight + offset; // Math.max(body.scrollHeight, body.offsetHeight, html.offsetHeight); <- this did not work in Edge & Safari, but clientHeight does just fine. However, clientHeight does not factor on scrollbars and margin/padding.
            var actualWrapperHeight = wrapper.height() + wrapperTop;
            if (height === formerHeight && actualWrapperHeight < height) return;

            formerHeight = height = actualWrapperHeight > height ? actualWrapperHeight + offset : height;

            parent.postMessage(JSON.stringify({
                "action": "resizeFrame",
                "height": height //  Note that adding or subtracting anything here will backfire and hurt you terribly. Don't.
            }), "*");
            return;
        };

        setInterval(doResize, 1000);

        window.performResize = doResize;
    })();
});

// === onLoad.js END ==============================================================================
